<template>
    <section :class="['ann-table-section', tableData.length === 0 && 'gray-section']">
        <Loading class="static" v-if="loading" />
        <div class="table-content-box" v-else-if="tableData.length !== 0 && !loading">
            <div class="top-box">
                <Pagenavi :disabled="false" :page_current="pageValue.current_page" :page_total="pageValue.total_page"
                    @goto-page="gotoPage" />
                <el-button type="primary" @click="handleAll(1)" v-if="props.whichType == 1"
                    :disabled="!tableData.some(e => e.pick)|| cantPublish">Publish</el-button>
                <el-button type="primary" @click="handleAll(2)" v-else-if="props.whichType == 2"
                    :disabled="!tableData.some(e => e.pick)|| cantPublish">Unpublish</el-button>
                <el-button type="primary" @click="handleAll(3)|| cantPublish" v-else-if="props.whichType == 3"
                    :disabled="!tableData.some(e => e.pick)">Archive</el-button>
                <el-button type="primary" @click="handleAll(4)|| cantPublish" v-else-if="props.whichType == 4"
                    :disabled="!tableData.some(e => e.pick)">Publish</el-button>
            </div>
            <el-table :data="tableData.filter(e => e.status_id === Number(props.whichType))" max-height="calc(95vh - 120px)">
                

                <el-table-column prop="pick" width="60" v-if="!cantPublish">
                    <template #header>
                        <Checkbox :checked="allSelected" @click="handleSelectionChange('all')" />
                    </template>
                    <template #default="{ row }">
                        <Checkbox :checked="row.pick" @click="handleSelectionChange(row)"
                            :disabled="!row.can_publish" />
                    </template>
                </el-table-column>
                
                <el-table-column prop="title" label="Content" show-overflow-tooltip width="250">
                    <template #default="{ row }">
                        <div class="td-title">
                            <img :src="row.thumbnail_url ? row.thumbnail_url : TempImg" alt="ann-icon" />
                            <div class="td-title-right">
                                <div class="p">{{ row.title }}</div>
                                <el-button size="mimi" @click="editAnn(row)" v-if="props.whichType === '1' || props.whichType === '2'"><svg-icon
                                        name="pen" /></el-button>
                                <el-button size="mimi" @click="viewAnn(row)" v-else><svg-icon
                                        name="eye" /></el-button>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="created_by_user_name" :label="'Owner'" width="120">
                    <template #header>
                        <div v-tippy="{ content: 'Owner' , delay: [500, 20] }">Owner</div>
                    </template>
                    <template #default="{ row }">
                        <span class="cre-by">{{ row.created_by_user_name }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="updated_at" label="Last Update" width="150">
                    <template #header>
                        <TableTh :name="'updated_at'" :title="'Last Update'" :sort_value="sortValue"
                            @sort="handleSortChange" :content="'Last Update'" />
                    </template>
                    <template #default="{ row }">
                        <span>{{ row.updated_by_user_name }}<br/>{{ row.lastUpdateDate }} </span><span>{{ row.lastUpdateTime }}</span>
                    </template>
                </el-table-column>

                <el-table-column v-if="props.whichType === '1'" prop="schedule_send_datetime" label="Send Method"
                    width="160">
                    <template #header>
                        <TableTh :name="'schedule_send_datetime'" :title="'Send Method'" :sort_value="sortValue"
                            @sort="handleSortChange" :content="'Send Method'" />
                    </template>
                    <template #default="{ row }">
                        <span>{{ row.send_option === 'now' ? 'Send now' : 'Send later' }}</span>
                        <span v-if="row.send_option !== 'now'">{{ row.scheduleSendDate }}</span>
                        <span v-if="row.send_option !== 'now'">{{ row.scheduleSendTime }}</span>
                    </template>
                </el-table-column>

                <el-table-column v-if="props.whichType !== '1' && props.whichType === '4'" prop="schedule_send_datetime"
                    :label="props.whichType == 3 ? 'Published' : 'Schedule'" width="160">
                    <template #header>
                        <TableTh :name="'schedule_send_datetime'"
                            :title="props.whichType == 3 ? 'Published' : 'Schedule'" :sort_value="sortValue"
                            @sort="handleSortChange"
                            :content="props.whichType == 3 ? 'Published' : 'Schedule'" />
                    </template>
                    <template #default="{ row }">
                        <span>{{ row.scheduleSendDate }}</span>
                        <span>{{ row.scheduleSendTime }}</span>
                    </template>
                </el-table-column>

                <el-table-column v-if="props.whichType === '3' || props.whichType === '4'" prop="opens" label="Opens" width="140">
                    <template #header>
                        <!-- <tippy :delay="[0, 20]" class="flex"
                            content="number of creators have click and opened this announcement">
                            <svg-icon name="question-3" />
                        </tippy> -->
                        <TableTh :name="'views'" :title="'Opens'" :sort_value="sortValue"
                            @sort="handleSortChange" :content="'number of creators have click and opened this announcement'" />
                    </template>
                    <template #default="{ row }">
                        <span>{{ row.views ? row.views: '---'}}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="recipients" label="Recipients" width="330">
                    <template #header>
                        <div v-tippy="{ content: 'Recipients', delay: [500, 20] }">Recipients</div>
                    </template>
                    <template #default="{ row }">
                        <span :class="['tags-list-box', row.showPopver && 'edit-tags-list-box']">
                            <Badage :class="['tag-item-box']" v-if="row.select_all_creator" :key="0" :value="'All'" />
                            <Badage :class="['tag-item-box', styleTagLong(row, v, k)]" v-else
                                v-for="(v, k) in row.all_recipient.filter((ee, kk) => { return kk < 2 })" :key="k"
                                :value="v.tag ? `${v.tag} (${v.creator_count})` : `${v.name}`" :show_tippy="true" />
                            <!-- 開關last_tag_all_open -->
                            <el-popover placement="bottom" :width="400" trigger="click" v-model:visible="row.showPopver"
                                @show="row.showPopver = true;" @hide="row.showPopver = false">
                                <template #reference>
                                    <Badage class="cursor-badage" v-if="row.all_recipient.length - 2 > 0"
                                        :value="`+${row.all_recipient.length - 2}`" />
                                </template>
                                <template #default>
                                    <div :class="['small-label']">
                                        <h3>All Recipients</h3>
                                        <svg-icon name="close" @click.stop="row.showPopver = false" />
                                    </div>
                                    <div class="tags-list-box-all">
                                        <Badage class="tag-item-box" v-for="(v, k) in row.all_recipient" :key="k"
                                            :value="v.tag ? `${v.tag} (${v.creator_count})` : `${v.name}`"
                                            :show_tippy="true" />
                                    </div>
                                </template>
                            </el-popover>

                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="Options" width="120">
                    <template #default="{ row }">
                        <div class="td-btn-box">
                            <el-button size="small" @click="viewAnn(row)" :text="props.whichType != 3">View</el-button>
                            <el-button size="small" v-if="props.whichType != 3" @click="editAnn(row)" :disabled="cantPublish">Edit</el-button>
                            <el-button type="primary" size="small" v-if="props.whichType == 1 && row.can_publish"
                                @click="publicAnn(row, true)" :disabled="cantPublish">Publish</el-button>
                            <el-button type="primary" size="small" v-if="props.whichType == 2"
                                @click="publicAnn(row, false)" :disabled="cantPublish">Unpublish</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </div>

        <!-- empty -->
        <Scrollbar v-else-if="tableData.length === 0 && !loading">
            <div class="empty-box">
                <h3>{{ emptyValue.title }}</h3>
                <p v-if="emptyValue.desc">{{ emptyValue.desc }}</p>
                <div class="btn-wrap" v-if="props.whichType !== '4'">
                    <el-button type="primary" size="large" @click="addNewAnn" :disabled="cantPublish">{{ props.whichType == 1? 'Start draft':'Draft announcement'}}</el-button>
                </div>
                <div class="content-value" v-if="emptyValue.content">
                    <div v-for="(item, index) in emptyValue.content" :key="index">
                        <svg-icon name="bold-arrow" />
                        <div class="left-value">
                            <h4>{{ item.title }}</h4>
                            <p>{{ item.value }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Scrollbar>
    </section>

    <el-dialog title="Archive announcement" width="400" v-model="isShowArchiveDialog" :show-close="false" @close="isShowArchiveDialog = false" class="archive-alert-dialog">
        <p>Creators that received this announcement will no longer be able to open it anymore.</p>
        <div class="btn-row">
            <el-button @click="isShowArchiveDialog = false">Cancel</el-button>
            <el-button type="primary" @click="handleArchiveApi(3)">Archive</el-button>
        </div>
    </el-dialog>
    
    <el-dialog title="Publish this announcement" width="400" v-model="isShowUnarchiveDialog" :show-close="false" @close="isShowUnarchiveDialog = false" class="archive-alert-dialog">
        <p>Creators that received this announcement will be able to open it anymore.</p>
        <div class="btn-row">
            <el-button @click="isShowUnarchiveDialog = false">Cancel</el-button>
            <el-button type="primary" @click="handleArchiveApi(1)">Publish</el-button>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, getCurrentInstance } from 'vue';
import {  ElButton, ElTable, ElTableColumn, ElPopover, ElDialog } from 'element-plus';
import emitter from '@/utils/EventBus';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import TempImg from '@/assets/images/no-image.png';
import moment from 'moment';
import Badage from '@/components/ui/Badage.vue';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import TableTh from '@/components/ui/TableTh.vue';
import Loading from '@/components/ui/Loading.vue';
import { useNotification } from '@/components/ui/notification';
import Store from '@/store/index.js';

const props = defineProps({
    whichType: {
        type: [String, Number],
        default: 1
    },
});
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const { openNotBottom } = useNotification();
const pageValue = ref({
    current_page: 1,
    total_page: 1,
})
const sortValue = ref({
    sort_key: 'updated_at',//updated_at/schedule_send_datetime
    sort_val: 'desc'//desc/asc
});
const tableData = ref([]);
const isShowArchiveDialog = ref(false);
const isShowUnarchiveDialog = ref(false);

const permission_mes = computed(() => {
    return Store.state.user_data?.permission_list?.messagesAndAnnouncements;
});

const cantPublish = computed(() => {
    return permission_mes.value.draftAndScheduleAndPublishAnnouncements.permission === 0;
});

const emptyValue = computed(() => {
    switch (props.whichType) {
        case '1':
            return {
                title: 'Send an announcement',
                content: [
                    {
                        title: 'Engage creators',
                        value: `Generate excitement around your program by sharing exclusive updates with your creator community, including new sales, challenges, and bonus opportunities.`
                    },
                    {
                        title: 'Tailor your announcements by group',
                        value: `With the ability to send an announcement to all creators or based on a creator tag, you can customize your communications for different groups you're working with. Don't worry – you can duplicate an announcement so you don't have to start from scratch every time.`
                    },
                    {
                        title: 'Extend communication touchpoints',
                        value: `Previews for your announcements will be published on the Creator Portal homepage and appear in their Messages tab. Creators can also receive an email notification that there is an announcement waiting for them in the Creator Portal.
                        `
                    },
                ]
            };
        case '2':
            return {
                title: 'No announcements scheduled yet'
            };
        case '3':
            return {
                title: 'No announcements published yet'
            };

        case '4':
            return {
                title: 'No archived announcements',
                desc: 'When you archive published announcements, they’ll show up here. Archived announcements will not be displayed in the creator portal. ',
            };
        default:
            return {
                title: 'Send an announcement'
            };
    }
});

const filterStatus = computed(() => {
    switch (props.whichType) {
        case '1':
            return 'draft';
        case '2':
            return 'scheduled';
        case '3':
            return 'active';
        case '4':
            return 'archived';
    }
});

const loading = ref(false);
const allSelected = ref(false);
//+++++++++++++++++++++++++++++++++++++
// Methods
//+++++++++++++++++++++++++++++++++++++
const addNewAnn = () => {
    let title = 'New Announcement';
    emitter.emit('open-edit-announcement', { title: title, type: props.whichType });
};

const handleTableData = () => {
    tableData.value.forEach(el => {
        el.lastUpdateDate = moment(el.updated_at).format('MMM DD, YYYY');
        el.lastUpdateTime = moment(el.updated_at).format('h:mm A');
        el.scheduleSendDate = el.schedule_send_datetime ? moment(el.schedule_send_datetime).format('MMM DD, YYYY') : '';
        el.scheduleSendTime = el.schedule_send_datetime ? moment(el.schedule_send_datetime).format('h:mm A') : '';
        el.showPopver = false;
        el.pick = false;

        el.status_id = el.status_name === 'active' ? 3 : el.status_name === 'scheduled' ? 2 : el.status_name === 'draft' ? 1 : 4;
        el.can_publish = el.status_id != 1 || (el.status_id == 1 && el.title && el.description && (el.send_option === 'now' || (el.send_option === 'later' && el.schedule_send_datetime)));
        el.all_recipient = [...el.recipient_creators, ...el.recipient_groups]
    });
};

const styleTagLong = (row, v, k) => {
    if (row.recipients && row.recipients.length === 1) {
        return `tag-item-box-only-one`
    } else if (row.recipients && row.recipients.length > 1) {
        if (row.recipients[0].text && row.recipients[0].text.length < 8 && k === 1) {
            return `tag-item-box-pick-long`
        } else if (row.recipients[1].text && row.recipients[1].text.length < 8 && k === 0) {
            return `tag-item-box-pick-long`
        } else if (row.recipients.length === 2) {
            return 'tag-item-box-longer';
        } else {
            return '';
        }
    } else {
        return '';
    }
};

const gotoPage = (page) => {
    pageValue.value.current_page = page;
    callListApi();
};

//checkbox
const handleSelectionChange = (selectedRows) => {
    if (selectedRows === 'all') {
        allSelected.value = !allSelected.value;
        tableData.value.forEach(row => {
            if (row.can_publish) row.pick = allSelected.value;
        });
    } else {
        tableData.value.forEach(row => {
            row.pick = row.id === selectedRows.id && row.can_publish ? !row.pick : row.pick;
        });
        allSelected.value = tableData.value.every(row => row.pick);
    }
};

const handleSortChange = (sort) => {
    if (sort === sortValue.value.sort_key) {
        sortValue.value.sort_val = sortValue.value.sort_val === 'asc' ? 'desc' : 'asc';
    } else {
        sortValue.value.sort_key = sort;
        sortValue.value.sort_val = 'asc';
    }
    //pageValue.value.current_page = 1;
    callListApi();
};

const viewAnn = (row) => {
    emitter.emit('open-edit-announcement', { title: '', type: props.whichType, data: row, is_view: true });
};

const editAnn = (row) => {
    let title = 'Edit Draft';
    if (props.whichType == 3) {
        title = 'Edit Published'
    } else if (props.whichType == 2) {
        title = 'Edit Scheduled';
    }
    emitter.emit('open-edit-announcement', { title: title, type: props.whichType, data: row, is_view: false });
};

const publicAnn = async (row, pub) => {
    handlePublishApi([row], pub);
};

const handleAll = (pub) => {
    switch (pub) {
        case 1:
        case 2:
            loading.value = true;
            const rows = tableData.value.filter(e => e.pick);
            handlePublishApi(rows, pub);
            break;
    
        case 3:
            isShowArchiveDialog.value = true;
            break;

        case 4:
            isShowUnarchiveDialog.value = true;
            break;
    }
};

const handleArchiveApi = async (pub) => {
    isShowUnarchiveDialog.value = false;
    isShowArchiveDialog.value = false;

    loading.value = true;
    const rows = tableData.value.filter(e => e.pick);
    handlePublishApi(rows, pub);
}

const handlePublishApi = async (rows, pub) => {
    let api = '';
    let text = '';
    const is_now = rows[0].send_option === 'now';

    switch (pub) {
        case 1:
            api = '/announcement/publish-announcement';
            text = `Announcement${rows.length > 1 ? `s` : ''} ${props.whichType === '4' ? 'published' : is_now ? `sent` : `scheduled`}.`;
            break;
        case 2:
            api = '/announcement/unpublish-announcement';
            text = `Announcement${rows.length > 1 ? `s` : ''} unpublished.`;
            break;
        case 3:
            api = '/announcement/archive-announcement';
            text = `Announcement${rows.length > 1 ? `s` : ''} archived.`;
            break;
    }
    // let api = pub ? '/announcement/publish-announcement' : '/announcement/unpublish-announcement';

    const data = { 
        ids: rows.map(e => e.id)
    };

    let formData = new FormData();
    for (let key in data) {
        if (Array.isArray(data[key])) {
            data[key].forEach(value => {
                formData.append(`${key}[]`, value);
            });
        } else {
            formData.append(key, data[key]);
        }
    }
    try {
        await ajax.post(api, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        
        openNotBottom(text, 'success');
        callListApi();
    } catch (error) {
        openNotBottom(`${pub ? 'Publish' : 'UnPublish'} failed.`, 'error');
    }
};

const callListApi = async () => {
    loading.value = true;
    try {
        const params = {
            filters: JSON.stringify([
                { field_name: 'status', value: filterStatus.value }
            ]),
            sort_key: sortValue.value.sort_key,
            sort_val: sortValue.value.sort_val,
            per_page: 20,
            page: pageValue.value.current_page,
            keyword: ''
        };
        const response = await ajax.get(`/announcement/list`, { params });
        const data = response.data.data;
        pageValue.value.current_page = data.current_page;
        pageValue.value.total_page = data.last_page;
        tableData.value = response.data.data.data;
        handleTableData();
    } catch (error) {
        console.error('Error fetching announcement list:', error);
    } finally {
        loading.value = false; // 確保無論成功或失敗，loading 都會被關閉
    }
};

const handleAnnouncement = async (val) => {
    sortValue.value.sort_val = 'desc';
    sortValue.value.sort_key = 'updated_at';
    pageValue.value.current_page = 1;
    await callListApi();
};
//+++++++++++++++++++++++++++++++++++++
//onMounted
//+++++++++++++++++++++++++++++++++++++
onMounted(async () => {
    await callListApi();
    emitter.on('call-table-announcement', handleAnnouncement);
});

onUnmounted(() => {
    emitter.off('call-table-announcement', handleAnnouncement);
});


</script>

<style lang="scss">

.archive-alert-dialog {
    header {
        padding: 6px !important;
    }

    .el-dialog__body {
        padding: 6px;

    }

    p {
        font-size: 16px;
        padding: 8px 0;
    }

    .btn-row {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding: 16px 0 0;
    }
}

.ann-table-section {

    &.gray-section {
        background-color: var(--bg-10);
    }

    .top-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .ui-pagenavi {
            width: 86px;
        }
    }



    .el-table {
        .el-table__header,
        .el-table__body {
            width: 100% !important;

        }

        thead tr th {
            background-color: var(--bg-10) !important;

            .ico {
                display: flex;
                align-items: center;

                svg {
                    height: 14px;
                    width: 14px;
                    display: block;
                    fill: var(--black-40);
                    margin-left: 6px;
                }

                &.sort {
                    cursor: pointer;

                    svg,
                    .svg-icon {
                        height: 12px;
                        width: 12px;
                    }

                    &:hover {
                        color: var(--black-90);

                        svg,
                        .svg-icon {
                            fill: var(--black-90);
                        }

                        .svg-icon--question {
                            fill: var(--black-40);
                        }
                    }

                    &.asc,
                    &.desc {
                        color: var(--dark-blue);

                        svg,
                        .svg-icon {
                            fill: var(--dark-blue);
                        }

                        .svg-icon--question {
                            fill: var(--dark-blue);
                        }
                    }

                    &.desc svg,
                    &.desc .svg-icon {
                        &.svg-icon--sort {
                            transform: rotate(-180deg);
                        }
                    }

                    .svg-icon--question:hover {
                        fill: var(--dark-blue);
                    }
                }
            }

            .cell {
                text-align: left;
                display: flex;
                gap: 4px;
                align-items: center;

                svg {
                    height: 14px;
                    width: 14px;
                    fill: var(--black-50);
                }
            }
        }

        tbody tr {
            &:first-child {
                td {
                    border-top: solid 1px var(--black-20);
                }
            }
        }

        tbody tr td {
            border-bottom: solid 1px var(--black-20);
        }

        input[type="checkbox"] {
            accent-color: var(--Brand-Primary);
        }

        svg {
            height: 12px;
            width: 12px;
            cursor: pointer;
        }

        .cell {
            .ui-checkbox {
                margin: 0;

                svg {
                    margin: 0;
                    width: 14px;
                    height: 14px;
                    fill: var(--Brand-Primary);
                }
            }
        }

        .td-title {
            display: flex;
            gap: 8px;
            align-items: center;

            img {
                aspect-ratio: 1/1;
                object-fit: contain;
                width: 80px;
                min-width: 80px;
                border: solid 1px var(--border);
                border-radius: 4px;
                overflow: hidden;
            }

            .p {
                font: var(--medium-12);
                word-wrap: break-word;
                white-space: normal;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-bottom: 4px;
            }
        }

        .tags-list-box {
            display: flex;
            align-items: center;
            padding: 4px;
            gap: 6px;
            transition: .3s;
            border: solid 1px var(--white);
            max-width: 300px;
            min-width: 300px;

            .my-badges-iden {
                display: flex;
                align-items: center;
                border-radius: 6px;

                span {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    max-width: 86px;
                }

                &.tag-item-box-only-one span {
                    max-width: 300px;
                }

                &.tag-item-box-longer span {
                    max-width: 150px;
                }

                &.tag-item-box-pick-long span {
                    max-width: 200px;
                }

                &:first-child {
                    span {
                        max-width: 150px;
                    }
                }
            }


            .svg-icon {
                margin-left: 6px;
                width: 0px;
                transition: opacity 0.3s ease;

                &.ths-show {
                    width: 8px;
                }
            }

            &.edit-tags-list-box {
                border: solid 1px var(--neutral);
                border-radius: 6px;

            }

        }

        .cursor-badage {
            cursor: pointer;
        }

        .td-btn-box {
            display: grid;
            gap: 8px;

            .el-button {
                margin: 0;
            }
        }

    }

    .empty-box {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        justify-content: center;
        gap: 16px;
        height: calc(100vh - 100px);
        // max-width: 800px;
        padding: 0 24px;
        margin: 0 auto;
        background-color: var(--bg-10);

        h3 {
            font: var(--medium-30);
            color: var(--Brand-Primary);
            width: 100%;
            text-align: center;
        }
        
        .btn-wrap {
            width: 100%;
            text-align: center;
            padding-bottom: 16px;
        }

        & > p {
            max-width: 680px;
            margin: 0 auto;
            text-align: center;
            font-size: 16px;
            color: var(--Text-primary);
        }

        .content-value {
            display: grid;
            gap: 16px;
            

            >div {
                display: grid;
                grid-template-columns: auto 1fr;
                gap: 16px;
                max-width: 800px;

                svg {
                    width: 20px;
                    height: 20px;
                    fill: var(--Brand-Primary);
                    margin-top: 4px;
                }

                h4 {
                    font: var(--medium-16);
                    color: var(--Text-primary);
                    margin-bottom: 4px;
                }

                p {
                    font-size: 12px;
                    color: var(--Text-secondary);
                }
            }
        }
    }
}

.el-popper {
    padding: 0;

    .small-label {
        padding: 12px;
        border-bottom: 1px solid var(--black-20);
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.label-center {
            border: none;
        }

        h3 {
            font-size: 12px;
            font-weight: 500;
            color: var(--black-75);
        }

        .svg-icon {
            width: 12px;
            height: 12px;
            cursor: pointer;
        }
    }

    .tags-list-box-all {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 4px;
        gap: 6px;
        transition: .3s;
        border: solid 1px var(--white);

        .my-badges-iden {
            display: flex;
            align-items: center;
            border-radius: 6px;
            max-height: 24px;

            span {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 120px;
            }

            &:first-child {
                span {
                    max-width: 150px;
                }
            }
        }


        .svg-icon {
            margin-left: 6px;
            width: 0px;
            transition: opacity 0.3s ease;
            cursor: pointer;

            &.ths-show {
                width: 8px !important;
            }
        }

        &.edit-tags-list-box {
            border: solid 1px var(--neutral);
            border-radius: 6px;

        }

    }
}
</style>